module.exports = __webpack_public_path__ + "static/img/9.b08b0d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/6/9.png
// module id = F9qd
// module chunks = 0